export default function () {
    if(detectIOS() === true) {
        document.body.classList.add('iOS');
    }
    function detectIOS() {
        var _ua = window.navigator.userAgent;
        if(_ua.indexOf('iPhone') !== -1 || _ua.indexOf('iPad') !== -1 || _ua.indexOf('iPod') !== -1) {
            return true;
        } else {
            return false;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/utils/detect-ios.js